import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { LocationModel } from '../../models/resources/location.model';

@Injectable({
  providedIn: 'root',
})
export class LocationService extends AResourceService<LocationModel> {

  constructor() {
    super('/locations', true, [
      'vehicles',
      ]);
  }
}
